import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import { Button } from '../components/ui/button';
import { leasingAdvantages, equipmentTypes } from '../mock';

export default function EquipmentLeasing() {
  return (
    <>
      <PageHero
        eyebrow="Equipment Leasing"
        title="Foxstone Commercial Leasing"
        subtitle="Leasing solutions for all types of new and used equipment assets to help grow your Canadian business."
        image="https://images.unsplash.com/photo-1503708928676-1cb796a0891e?w=1920&q=80"
      />

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">Why lease with Foxstone?</p>
            <h2 className="font-display text-3xl lg:text-4xl text-fx-navy font-bold mt-3">A flexible approach across every equipment class</h2>
            <div className="fx-section-divider mt-5" />
            <p className="mt-6 text-slate-700 leading-relaxed">
              We take a flexible approach to provide lease financing across a wide spectrum of equipment classes and tailor solutions to the industries we serve. Whether you are acquiring your first asset or refreshing your entire fleet, our team structures terms that match your cashflow — not the other way around.
            </p>
            <Button asChild className="mt-7 bg-fx-navy hover:bg-fx-navy-deep text-white rounded-sm h-12 px-7">
              <Link to="/contact">Get Started <ArrowRight className="w-4 h-4 ml-2" /></Link>
            </Button>
          </div>
          <div className="lg:col-span-5">
            <div className="bg-fx-cream rounded-lg p-7 border border-fx-gold/30">
              <h3 className="font-display text-xl text-fx-navy font-bold">Equipment we finance</h3>
              <ul className="grid grid-cols-1 gap-2 mt-4">
                {equipmentTypes.map((e, i) => (
                  <li key={i} className="flex gap-2.5 text-sm text-slate-700"><CheckCircle2 className="w-4 h-4 text-fx-gold shrink-0 mt-0.5" /><span>{e}</span></li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-fx-slate">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center max-w-2xl mx-auto">
            <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">Why lease</p>
            <h2 className="font-display text-4xl text-fx-navy font-bold mt-3">The advantages of leasing</h2>
            <div className="fx-section-divider mx-auto mt-5" />
          </div>
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {leasingAdvantages.map((adv, i) => {
              const Icon = Icons[adv.icon] || Icons.Sparkles;
              return (
                <div key={i} className="bg-white rounded-lg p-8 border border-slate-100 fx-lift">
                  <div className="w-12 h-12 rounded-md bg-fx-navy text-fx-gold flex items-center justify-center">
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-display text-xl text-fx-navy font-bold mt-5">{adv.title}</h3>
                  <ul className="mt-4 space-y-2.5">
                    {adv.points.map((p, idx) => (
                      <li key={idx} className="flex gap-2.5 text-sm text-slate-700"><CheckCircle2 className="w-4 h-4 text-fx-gold shrink-0 mt-0.5" /><span>{p}</span></li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
